// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd68c2e2","453":"d8ea84dd","644":"4c4d6f37","732":"91382ef6"}[chunkId] + ".chunk.js";
};